<div
  #tableContainer
  [ngClass]="['app-table--' + layoutStyle]"
  [class.app-table--drag-scroll-enabled]="shouldEnableDragScroll"
  [style.bottom.px]="layoutStyle === appTable.layoutStyle.ABSOLUTE_WITH_TOP_BOTTOM ? bottom : 'auto'"
  [style.top.px]="layoutStyle === appTable.layoutStyle.ABSOLUTE_WITH_TOP_BOTTOM ? top : 'auto'"
  class="app-table"
  [appDragScroll]="shouldEnableDragScroll"
>
  <qima-table [qimaTableIsStriped]="isStriped">
    @if (isHeadVisible) {
      <qima-table-head [ngClass]="{ 'app-table__fix-header': isHeaderFix }">
        @if (stickyLeftHeaders.length) {
          <div
            #stickyLeftRef
            [style.width.px]="stickyLeftHeadersWidth"
            class="app-table__columns-sticky-left qima-table-head-cell"
          >
            @for (header of stickyLeftHeaders; track header.id ?? header.key ?? $index; let index = $index) {
              @if (!header.hide) {
                @if (header.type === appTableDataCellService.tableDataType.CHECKBOX) {
                  <qima-table-head-cell-checkbox
                    (qimaTableHeadCellCheckboxClick)="onHeadCellCheckboxClick(index)"
                    [qimaTableHeadCellCheckboxState]="headCellCheckboxState"
                  ></qima-table-head-cell-checkbox>
                }
                @if (header.type !== appTableDataCellService.tableDataType.CHECKBOX && !header.iconName) {
                  <qima-table-head-cell
                    (qimaTableHeadCellSortAscendingChange)="onSortAscendingChange($event, header.sortKey || header.key || '')"
                    [appTableHeadCellSuffix]="header.headerSuffixComponent"
                    [qimaTableHeadCellLabel]="header.label | translate"
                    [qimaTableHeadCellSort]="header.sortType ?? undefined"
                    [qimaTableHeadCellTooltip]="header.tooltip || '' | translate"
                    [style.width]="resolveTableColumnWidth(header?.width)"
                    [class]="header?.class"
                  ></qima-table-head-cell>
                }
                <ng-container *ngTemplateOutlet="headerIcon; context: { header }"></ng-container>
              }
            }
          </div>
        }
        @for (header of renderedTableHeaders; track header.id ?? header.key ?? $index; let index = $index) {
          @if (!header.hide) {
            @if (header.type === appTableDataCellService.tableDataType.CHECKBOX) {
              <qima-table-head-cell-checkbox
                (qimaTableHeadCellCheckboxClick)="onHeadCellCheckboxClick(index)"
                [qimaTableHeadCellCheckboxState]="headCellCheckboxState"
              ></qima-table-head-cell-checkbox>
            }
            @if (header.type !== appTableDataCellService.tableDataType.CHECKBOX && !header.iconName) {
              <qima-table-head-cell
                (qimaTableHeadCellSortAscendingChange)="onSortAscendingChange($event, header.sortKey || header.key || '')"
                [appTableHeadCellSuffix]="header.headerSuffixComponent"
                [qimaTableHeadCellLabel]="header.label | translate"
                [qimaTableHeadCellSort]="header.sortType ?? undefined"
                [qimaTableHeadCellTooltip]="header.tooltip || '' | translate"
                [style.width]="resolveTableColumnWidth(header?.width)"
                [class]="header?.class"
              ></qima-table-head-cell>
            }
            <ng-container *ngTemplateOutlet="headerIcon; context: { header }"></ng-container>
          }
        }
        @if (stickyRightHeaders.length) {
          <div
            #stickyRightRef
            [style.width.px]="stickyRightHeadersWidth"
            class="app-table__columns-sticky-right qima-table-head-cell"
          >
            @for (header of stickyRightHeaders; track header.id ?? header.key ?? $index; let index = $index) {
              @if (!header.hide) {
                @if (header.type === appTableDataCellService.tableDataType.CHECKBOX) {
                  <qima-table-head-cell-checkbox
                    (qimaTableHeadCellCheckboxClick)="onHeadCellCheckboxClick(index)"
                    [qimaTableHeadCellCheckboxState]="headCellCheckboxState"
                  ></qima-table-head-cell-checkbox>
                }
                @if (header.type !== appTableDataCellService.tableDataType.CHECKBOX && !header.iconName) {
                  <qima-table-head-cell
                    (qimaTableHeadCellSortAscendingChange)="onSortAscendingChange($event, header.sortKey || header.key || '')"
                    [appTableHeadCellSuffix]="header.headerSuffixComponent"
                    [qimaTableHeadCellLabel]="header.label | translate"
                    [qimaTableHeadCellSort]="header.sortType ?? undefined"
                    [qimaTableHeadCellTooltip]="header.tooltip || '' | translate"
                    [style.width]="resolveTableColumnWidth(header?.width)"
                    [class]="header?.class"
                  ></qima-table-head-cell>
                }
                <ng-container *ngTemplateOutlet="headerIcon; context: { header }"></ng-container>
              }
            }
          </div>
        }
      </qima-table-head>
    }
    <qima-table-body>
      @for (row of tableData; track row.rowId ?? $index; let rowIndex = $index) {
        <qima-table-row
          (click)="onRowClick(rowIndex, row)"
          (keydown.enter)="onRowEnter(rowIndex, row)"
          [class.app-table__body-row--disabled]="row.isRowDisabled"
          [class.app-table__can-click]="canClick"
          [class.app-table__hover]="isHover"
          [class.app-table__select-row]="activeRowIndex === rowIndex && hasSelectedBackgroundColor"
          qimaTooltip
          [qimaTooltipIsVisible]="getRowTooltipConfig(row).isVisible ?? false"
          [qimaTooltipText]="getRowTooltipConfig(row).text ?? '' | translate"
          [qimaTooltipHasArrow]="getRowTooltipConfig(row).hasArrow ?? true"
        >
          @if (row.stickyLeftData?.length) {
            <div
              #stickyLeftRef
              class="app-table__columns-sticky-left"
              [class.app-table__columns-sticky-left--striped]="isStriped && rowIndex % 2 === 0"
            >
              <ng-container *ngTemplateOutlet="cells; context: { row, rowData: row.stickyLeftData, rowIndex, headers: stickyLeftHeaders }"></ng-container>
            </div>
          }
          <ng-container *ngTemplateOutlet="cells; context: { row, rowData: row.renderedData, rowIndex, headers: renderedTableHeaders }"></ng-container>
          @if (row.stickyRightData?.length) {
            <div
              #stickyRightRef
              class="app-table__columns-sticky-right"
              [class.app-table__columns-sticky-right--striped]="isStriped && rowIndex % 2 === 0"
            >
              <ng-container *ngTemplateOutlet="cells; context: { row, rowData: row.stickyRightData, rowIndex, headers: stickyRightHeaders }"></ng-container>
            </div>
          }
        </qima-table-row>
      }
    </qima-table-body>
  </qima-table>
  @if (!tableData.length) {
    <app-empty-content [emptyContentMessage]="emptyMessage"></app-empty-content>
  }
</div>

<ng-template
  #headerIcon
  let-header="header"
>
  @if (header.iconName) {
    <qima-button-icon
      [style.width]="resolveTableColumnWidth(header.width)"
      class="header-icon"
      [qimaButtonIconName]="header.iconName"
      [qimaButtonIconStyle]="qimaButton.buttonIconStyle.TERTIARY"
      (qimaButtonIconClick)="header.headerClick?.()"
    ></qima-button-icon>
  }
</ng-template>

<ng-template
  #cells
  let-headers="headers"
  let-row="row"
  let-rowData="rowData"
  let-rowIndex="rowIndex"
>
  @for (cellData of rowData; track $index; let columnIndex = $index) {
    @if (!headers[columnIndex]?.hide) {
      @if (cellData.type === appTableDataCellService.tableDataType.CHECKBOX && !cellData.checkIsDisabled) {
        <qima-table-body-cell-checkbox
          (click)="onCellCheckboxClick($event)"
          (qimaTableBodyCellCheckboxClick)="onTableBodyCellCheckboxClick($event, cellData, row)"
          [qimaTableBodyCellCheckboxState]="cellData.checkState"
        ></qima-table-body-cell-checkbox>
      }

      @if (cellData.type === appTableDataCellService.tableDataType.CHECKBOX && cellData.checkIsDisabled) {
        <span
          class="app-table__body-cell-checkbox app-table__body-cell-checkbox--disabled"
          qimaTooltip
          [qimaTooltipHasArrow]="true"
          [qimaTooltipIsVisible]="!!cellData.tooltip"
          [qimaTooltipText]="cellData.tooltip || '' | translate"
        >
          <qima-table-body-cell-checkbox
            (click)="onCellCheckboxClick($event)"
            [qimaTableBodyCellCheckboxState]="cellData.checkState"
          ></qima-table-body-cell-checkbox>
        </span>
      }

      @if (cellData.type !== appTableDataCellService.tableDataType.CHECKBOX) {
        @let columnHeader = headers[columnIndex];
        @let isFixedWidthColumn = columnHeader?.isFixedWidth;
        @let fixedColumnWidth = isFixedWidthColumn ? resolveTableColumnWidth(columnHeader?.width) : null;

        @if (!cellData.customizedCellConfiguration) {
          <app-common-table-cell
            (click)="cellData.cellClick?.($event)"
            (commonTableDecisionApprove)="onDecisionApprove($event)"
            (commonTableDecisionReject)="onDecisionReject($event)"
            (commonTableIconCellClick)="onIconCellClick($event)"
            [class.app-table__fixed-width-cell]="isFixedWidthColumn"
            [style.max-width]="fixedColumnWidth"
            [style.min-width]="fixedColumnWidth"
            [style.width]="fixedColumnWidth"
            [commonTableCellData]="cellData"
            [commonTableCellHeader]="columnHeader"
            [commonTableCellIndex]="rowIndex"
            [commonTableCellOriginData]="row.originData"
            [commonTableCellWidth]="columnHeader?.width || 'auto'"
            data-cy="table-common-cell"
          ></app-common-table-cell>
        }

        @if (cellData.customizedCellConfiguration) {
          <app-customized-table-cell
            [class.app-table__fixed-width-cell]="isFixedWidthColumn"
            [style.max-width]="fixedColumnWidth"
            [style.min-width]="fixedColumnWidth"
            [style.width]="fixedColumnWidth"
            [customizedTableCellConfiguration]="cellData.customizedCellConfiguration"
            [customizedTableCellWidth]="columnHeader?.width || 'auto'"
            data-cy="table-customized-cell"
          ></app-customized-table-cell>
        }
      }
    }
  }
</ng-template>
